import React from "react";
import { ButtonLoader } from "./ButtonLoader";

export function ConfirmPopUp({notif='',onClick=()=>{}, ConfirmPopState,setConfimPopState})
{
    if(!!ConfirmPopState && !ConfirmPopState.trigger)
        return
    else
        return(
            <div className="back-screen" style={{position:'fixed',top:'0px',left:'0px', backgroundColor:'rgba(0,0,0,0.7)'}}>
                <div className="confirm-popup" style={{margin:'auto',backgroundColor:'white',width:'90%',borderRadius:'10px ',padding:'10px',position:'relative',top:'200px'}}>
                    <span>{notif}</span>
                    <div style={{width:'50%',margin:'auto',height:'40px',marginTop:'20px'}}>
                        { <ButtonLoader loading={ConfirmPopState.loader.loading} text={ConfirmPopState.loader.text} />}
                    </div>
                    <div style={{width:'100%',margin:'auto',height:'40px',marginTop:'5px'}}>
                        <input onClick={e=>{setConfimPopState({...ConfirmPopState,trigger:false})}} type="button" value={'Fermer'} style={{height:'40px',width:'50%'}} />
                    </div>
                </div>
            </div>
        );
}